import { render, staticRenderFns } from "./input-card.vue?vue&type=template&id=505a3d45&scoped=true"
import script from "./input-card.vue?vue&type=script&lang=ts"
export * from "./input-card.vue?vue&type=script&lang=ts"
import style0 from "./input-card.vue?vue&type=style&index=0&id=505a3d45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a3d45",
  null
  
)

export default component.exports